import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "text-sm font-medium text-gray-700 mb-1" }
const _hoisted_2 = { class: "flex flex-wrap gap-2" }
const _hoisted_3 = ["disabled", "title", "onClick"]
const _hoisted_4 = {
  key: 0,
  class: "text-red-800 text-sm ml-0.5"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-col py-2 px-3 relative w-full", _ctx.tclass])
  }, [
    _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.label), 1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: String(item.value),
          type: "button",
          disabled: !!item.disabled,
          title: item.disabled ? item.disabledTitle ?? '' : '',
          class: _normalizeClass(["flex-1 px-4 py-3 rounded-lg border text-base font-medium transition-colors duration-150 flex items-center justify-center gap-2 focus:outline-none", 
          item.disabled
            ? 'bg-gray-100 border-gray-200 text-gray-400 cursor-not-allowed'
            : String(_ctx.value) === String(item.value)
            ? `bg-${_ctx.theme}-800 border-${_ctx.theme}-800 text-white shadow`
            : `bg-white border-gray-300 text-gray-700 hover:border-${_ctx.theme}-400 hover:bg-${_ctx.theme}-50 cursor-pointer`
        ]),
          onClick: ($event: any) => (_ctx.onSelect(item))
        }, [
          (item.icon)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: item.icon
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
          _createTextVNode(" " + _toDisplayString(item.name), 1)
        ], 10, _hoisted_3))
      }), 128))
    ]),
    (_ctx.error && _ctx.error.length > 0)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.error), 1))
      : _createCommentVNode("", true)
  ], 2))
}